import dayjs from 'dayjs';
import { ApiEndpointClient } from './resource-client';
const DATA_API_PREFIX = 'data-api/v1';
export class MarketDataClient extends ApiEndpointClient {
    constructor(http) {
        super(http, DATA_API_PREFIX);
    }
    getMarketData = async ({ latitude, longitude, assetId, customerId, }) => {
        const query = {};
        if (latitude && longitude) {
            query.latitude = latitude.toString();
            query.longitude = longitude.toString();
        }
        if (assetId)
            query.asset_uuid = assetId;
        if (customerId)
            query.customer_uuid = customerId;
        return this.get('/market', { query });
    };
    getRegions = async ({ name }) => {
        return this.get('/market-data/regions', { query: name ? { name } : {} });
    };
    getPublishers = async ({ name }) => {
        return this.get('/market-data/publishers', { query: name ? { name } : {} });
    };
    patchPublisher = async ({ publisherId, operations, }) => {
        await this.patch(`/market-data/publishers/${publisherId}`, { json: operations, response: 'raw' });
    };
    createPublisher = async (newPublisher) => {
        return this.post('/market-data/publishers', { json: newPublisher });
    };
    getOriginLinks = async ({ name }) => {
        return this.get('/market-data/links', { query: name ? { name } : {} });
    };
    createOriginLink = async (input) => {
        return this.post('/market-data/links', { json: input });
    };
    patchOriginLink = async ({ linkId, operations }) => {
        await this.patch(`/market-data/links/${linkId}`, { json: operations, response: 'raw' });
    };
    getOriginInformalSources = async ({ name }) => {
        return this.get('/market-data/informal-sources', { query: name ? { name } : {} });
    };
    createOriginInformalSource = async (input) => {
        return this.post('/market-data/informal-sources', { json: input });
    };
    patchOriginInformalSource = async ({ sourceId, operations, }) => {
        await this.patch(`/market-data/informal-sources/${sourceId}`, { json: operations, response: 'raw' });
    };
    getOriginDocuments = async ({ name }) => {
        return this.get('/market-data/documents', { query: name ? { name } : {} });
    };
    patchOriginDocument = async ({ documentId, operations, }) => {
        await this.patch(`/market-data/documents/${documentId}`, { json: operations, response: 'raw' });
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Preserve the legacy upload response type until a separate contract change.
    createOriginDocument = async ({ document }) => {
        const body = new FormData();
        body.append('file', document);
        return this.post('/market-data/documents', { body });
    };
    getMarketTimeSeries = async ({ publisherName, usageType, groupType, regionName, coordinates, }) => {
        const query = {};
        if (publisherName) {
            query.publisher_name = publisherName;
        }
        if (usageType) {
            query.usage_type = usageType;
        }
        if (groupType) {
            query.group_type = groupType;
        }
        if (regionName) {
            query.region_name = regionName;
        }
        if (coordinates) {
            query.latitude = coordinates.latitude.toString();
            query.longitude = coordinates.longitude.toString();
        }
        return this.get('/market-data/time-series', { query });
    };
    getMarketDataPoints = async ({ publisherName, usageType, groupType, regionName, dateTo, dateFrom, coordinates, }) => {
        const query = {};
        if (publisherName) {
            query.publisher_name = publisherName;
        }
        if (usageType) {
            query.usage_type = usageType;
        }
        if (groupType) {
            query.group_type = groupType;
        }
        if (regionName) {
            query.region_name = regionName;
        }
        if (dateFrom) {
            query.date_gte = dayjs(dateFrom).format('YYYY-MM-DD');
        }
        if (dateTo) {
            query.date_lte = dayjs(dateTo).format('YYYY-MM-DD');
        }
        if (coordinates) {
            query.latitude = coordinates.latitude.toString();
            query.longitude = coordinates.longitude.toString();
        }
        return this.get('/market-data/points', { query });
    };
    createMarketTimeSeries = async (input) => {
        return this.post('/market-data/time-series', { json: input });
    };
    patchMarketDataTimeSeries = async ({ timeSeriesId, operations, }) => {
        await this.patch(`/market-data/time-series/${timeSeriesId}`, { json: operations, response: 'raw' });
    };
    patchMarketDataPoint = async ({ pointId, operations }) => {
        await this.patch(`/market-data/points/${pointId}`, { json: operations, response: 'raw' });
    };
}
